import React, { Component, ComponentClass, ReactNode } from "react";
import { Provider } from "react-redux";
import { Store } from "redux";

import { StoreManager } from "./StoreManager";

export type RootComponentProps = {
    children: ReactNode;
};

/**
 * Typ pro kořenovou komponentu obsahující definicí kořenových props.
 */
export type RootComponentClass = ComponentClass<RootComponentProps>;

/**
 * Vytvoří kořenovou komponentu pro React aplikaci, která poskytuje pro své potomky přístup k redux stavu
 * a zachytává chyby z komponent, reducerů a ság. Chyby jsou delegovány k ošetření v původní aplikaci pomocí
 * bridge modulu.
 *
 * @param isDevMode Indikace vývojového módu. Pokud je aktivní, zapojí se do middleware redux-dev-tools.
 */
export const createRootComponent = (isDevMode: boolean): RootComponentClass => {
    class RootComponent extends Component<RootComponentProps> {
        private readonly _store: Store;

        constructor(props: RootComponentProps) {
            super(props);
            this._store = StoreManager.getStore(isDevMode);
        }

        public override componentDidCatch(error: Error): void {
            StoreManager.handleError(error);
        }

        public override render(): JSX.Element {
            return <Provider {...this.props} store={this._store}/>;
        }
    }

    return RootComponent;
};
